module.exports = __webpack_public_path__ + "media/images/iconClose__accent--dark-298c4c1a1579989a07eff2a173610f55.png";